import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';

/**
 * Creates a close button with optional color override
 *
 * @component
 * @param onClose - Function to call when button clicked.
 * @param color - Optional color override for the button
 * @returns {React.Element}
 */
export const CloseButton = ({ onClose, color }) => {
    return (
        <IconButton
            onClick={onClose}
            aria-label='Close'
            data-analyticsid='close-button'
        >
            <CloseIcon sx={{ transform: 'scale(1.1)', fill: color }} />
        </IconButton>
    );
};

CloseButton.propTypes = {
    onClose: PropTypes.func.isRequired,
    color: PropTypes.string
};
